import { createSelector } from '@reduxjs/toolkit';
import { EBalconyType } from '../../../../packages/JsonQuery';
import { selectBalconies, selectHasLoggia } from 'shared/selectors/jsonQuery';

export const selectBalconyValue = createSelector([selectBalconies, selectHasLoggia], (balconies, hasLoggia) => {
  const balconyTypes: EBalconyType[] = [];

  if (balconies && balconies.gte && balconies.gte > 0) {
    balconyTypes.push(EBalconyType.Balcony);
  }

  if (hasLoggia) {
    balconyTypes.push(EBalconyType.Loggia);
  }

  return balconyTypes.length > 0 ? balconyTypes : [null];
});
